<template>
  <w-main-template :side-border-resize-flag="true">
    <w-target-tree slot="sideContent" />
    <w-main-title slot="mainTitle">
      <div slot="title">
        <div class="vertical-center-box">
          <div class="title-h2" style="margin=left:5px;margin-bottom:0px;">{{title}}</div>
          <div v-show="subTitle !== null" class="info-text text-medium" style="display:inline-block;margin-left:10px;">
            {{subTitle}}
          </div>
        </div>
      </div>
      <div slot="rightTool">
        <w-manage-tool-button-set v-show="isObj" :obj="selectedNode.obj" />
        <w-datetime-range-button v-show="activeTabName === 'event-hist'" />
        <w-report-button/>
      </div>
    </w-main-title>
    <div slot="mainContent" class="page-container-content tabgroup">
      <w-tool-tabs v-model="activeTabName">
        <el-tab-pane :label="tabs['event-status'].label" :name="tabs['event-status'].name" class="h100 w100">
          <div class="full-wrapper">
            <el-scrollbar :ref="`${tabs['event-status'].name}-scrollbar`">
              <div class="full">
                <w-event-status ref="eventStatusRef" :active="tabs['event-status'].active"/>
              </div>
            </el-scrollbar>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="tabs['event-hist'].label" :name="tabs['event-hist'].name" class="h100 w100">
          <div class="full-wrapper">
            <el-scrollbar :ref="`${tabs['event-hist'].name}-scrollbar`">
              <div>
                <w-event-hist ref="eventHistRef" :active="tabs['event-hist'].active" />
              </div>
            </el-scrollbar>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="tabs['trouble-ticket'].label" :name="tabs['trouble-ticket'].name" class="h100 w100">
          <div class="full-wrapper">
            <el-scrollbar :ref="`${tabs['trouble-ticket'].name}-scrollbar`">
              <div class="full">
                <w-trouble-ticket :active="tabs['trouble-ticket'].active"/>
              </div>
            </el-scrollbar>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="tabs['event-predict'].label" :name="tabs['event-predict'].name" class="h100 w100">
          <div class="full-wrapper">
            <el-scrollbar :ref="`${tabs['event-predict'].name}-scrollbar`">
              <div class="full">
                <w-event-predict :active="tabs['event-predict'].active"/>
              </div>
            </el-scrollbar>
          </div>
        </el-tab-pane>
        <el-row slot="tool" type="flex" justify="end">
          <div class="vertical-center-box" v-if="activeTabName == 'event-status' || activeTabName == 'event-hist'">
            <w-smart-analyzer-button class="mr-r4" style="display:inline-block;" :activeTab="activeTabName"></w-smart-analyzer-button>
            <w-event-ticket-add-button class="mr-r4" style="display:inline-block;" :active-tab="activeTabName" @load-data="loadData"></w-event-ticket-add-button>
          </div>
          <div class="vertical-center-box">
            <w-kedb-list-popup-button class="mr-r4" />
            <w-event-predict-analysis-button class="mr-r4"/>
          </div>
        </el-row>
      </w-tool-tabs>
      <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop"/>
    </div>
  </w-main-template>
</template>

<script>
import isNil from 'lodash/isNil';
import RouterTab from '@/mixins/router/tab';
import WMainTemplate from '@/components/template/MainTemplate';
import WMainTitle from '@/components/template/MainTitle';
import WDatetimeRangeButton from '@/components/button/DatetimeRangeButton';
import WReportButton from '@/components/button/ReportButton';
import WManageToolButtonSet from '@/components/button/ManageToolButtonSet';
import WTargetTree from '@/components/tree/TargetTree';
import ScrollbarMixin from '@/mixins/scrollbar';
import { isRequireIPObjType } from '@/utils/tree';
import WEventStatus from './event-status';
import WEventHist from './event-hist';
import WTroubleTicket from './trouble-ticket';
import WEventPredict from './event-predict';
import WSmartAnalyzerButton from './components/SmartAnalyzerButton';
import WEventTicketAddButton from './components/EventTicketAddButton';
import WKedbListPopupButton from './kedb/components/button/KedbListPopupButton';
import WEventPredictAnalysisButton from './components/EventPredictAnalysisButton';

export default {
  name: 'WEvent',
  mixins: [RouterTab, ScrollbarMixin],
  components: {
    WMainTemplate,
    WMainTitle,
    WDatetimeRangeButton,
    WReportButton,
    WManageToolButtonSet,
    WTargetTree,
    WEventStatus,
    WEventHist,
    WTroubleTicket,
    WEventPredict,
    WSmartAnalyzerButton,
    WEventTicketAddButton,
    WKedbListPopupButton,
    WEventPredictAnalysisButton,
  },
  data() {
    return {
      tabs: {
        'event-status': {
          name: 'event-status',
          label: '이벤트 현황',
          active: false,
          default: true,
        },
        'event-hist': {
          name: 'event-hist',
          label: '이벤트 이력',
          active: false,
        },
        'trouble-ticket': {
          name: 'trouble-ticket',
          label: '장애 티켓',
          active: false,
        },
        'event-predict': {
          name: 'event-predict',
          label: '사전 예측 이벤트',
          active: false,
        },
      },
      scrollbarRef: 'event-status-scrollbar',
    };
  },
  computed: {
    /**
     * 트리에서 선택된 노드 객체
     * @author Ju
     * @return {Object} [description]
     */
    selectedNode() {
      return this.$store.getters.selectedNode;
    },
    /**
     * 타이틀
     * 트리에 선택된 노드 라벨을 제공.
     * @author Ju
     * @return {String} [description]
     */
    title() {
      return this.selectedNode.label;
    },
    /**
     * 서브 타이틀 (IP/URL 정보 표현)
     * @author Ju
     * @return {String}
     */
    subTitle() {
      let title = null;
      const node = this.selectedNode;
      if (!this.showFlowAnalysis && node.type === 'obj') {
        if (isRequireIPObjType(node) && (!isNil(node.ipaddress) || !isNil(node.parentIpaddress))) {
          title = isNil(node.ipaddress) ? node.parentIpaddress : node.ipaddress;
        } else if (node.subType === 'e2e' && !isNil(node.httpUrl)) {
          title = node.httpUrl;
        }
      }
      return title;
    },
    /**
     * 선택된 노드 타입이 Obj인지 여부
     * @author Ju
     * @return {Boolean} [description]
     */
    isObj() {
      return this.$store.getters.isObj;
    },
  },
  watch: {
    activeTab: {
      immediate: true,
      handler(to) {
        if (to) {
          this.scrollbarRef = `${to.name}-scrollbar`;
          this.$nextTick(() => {
            this.setScrollData();
          });
        }
      },
    },
  },
  created() {
    this.$store.dispatch('setInitialDatetimeRange', { type: 'interval', interval: 'hour', value: 12 });
    this.$store.dispatch('setPlotLineDatetime', null);
  },
  // mounted() {
  //   const defaultTabName = this.findDefaultTab(this.tabs).name;
  //   this.scrollbarRef = `${defaultTabName}-scrollbar`;
  //   this.setScrollData();
  // },
  methods: {
    loadData() {
      if (this.activeTab.name === 'event-status') {
        this.$refs.eventStatusRef.loadData();
      } else {
        this.$refs.eventHistRef.loadData();
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/event/index.vue